export interface DataEntity_Resolution_05_Interface {
  id: number,
  range_min:string,
  range_max:string,
  scale:string,
  status:number,
}

export function Empty_DataEntity_Resolution_05_Interface(): DataEntity_Resolution_05_Interface {
  return {
    id: 0,
    range_min:'',
    range_max:'',
    scale: '',
    status:0
  }
}
